import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paymentterms',
  templateUrl: './paymentterms.component.html',
  styleUrls: ['./paymentterms.component.scss']
})
export class PaymenttermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
